import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaSearch, FaTicketAlt } from 'react-icons/fa';

/**
 * HowItWorksSection - Displays the "How It Works" section
 * Extracted from LoyaltyDirectory to reduce file size
 */
function HowItWorksSection() {
  const { t } = useTranslation();

  return (
    <section id="how-it-works-section" className="perks-how-it-works">
      <h2>{t('directory.howItWorks')}</h2>
      <div className="perks-steps">
        <div className="perks-step">
          <div className="perks-step-icon">
            <FaEnvelope />
          </div>
          <div className="perks-step-content">
            <h3>{t('directory.step1Title')}</h3>
            <p>{t('directory.step1Description')}</p>
          </div>
        </div>
        <div className="perks-step">
          <div className="perks-step-icon">
            <FaSearch />
          </div>
          <div className="perks-step-content">
            <h3>{t('directory.step2Title')}</h3>
            <p>{t('directory.step2Description')}</p>
          </div>
        </div>
        <div className="perks-step">
          <div className="perks-step-icon">
            <FaTicketAlt />
          </div>
          <div className="perks-step-content">
            <h3>{t('directory.step3Title')}</h3>
            <p>{t('directory.step3Description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
